import {
  Box,
  CircularProgress,
  Modal,
  Typography,
  Button,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  approveClientAction,
  approveMultipleClientAction,
} from "../../../store/actions/client";
import { alertDialogAciton } from "../../../store/actions/auth";
import PropTypes from "prop-types";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import { phoneNumberFormat } from "../../../utils/methods/formatters";
import _ from "lodash";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  boxShadow: "none",
  p: 4,
  borderRadius: "8px",
  padding: "20px",
  border: "1px solid #D175B6",
  backgroundColor: "#000",
  zIndex: 9,
  "@media (max-width: 600px)": {
    minWidth: "96vw",
    maxHeight: "96vh",
    width: "97vw",
    overflowY: "auto",
  },
};

export const ClientApproveModal = ({
  open,
  onClose,
  row,
  onApproved,
  isGenerateEstimate = false,
  isAssign = false,
}) => {
  const dispatch = useDispatch();
  const [approvalLoading, setApprovalLoading] = useState(false);
  const [clientDetails, setClientDetails] = useState(null);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const handleClose = () => {
    if (onClose) onClose();
  };

  useEffect(() => {
    if (!row) return;
    if (row?.length > 1) {
      setClientDetails(row?.filter((item) => !item?.isApproved));
    } else {
      if (isAssign) {
        setClientDetails(row);
      } else {
        setClientDetails(
          row?.foundClients?.find((item) => item?._id === row?.userId),
        );
      }
    }
  }, [row, isAssign]);

  const handleApprove = () => {
    setApprovalLoading(true);

    dispatch(
      approveMultipleClientAction({
        payload: {
          data: {
            ids: _.isArray(clientDetails)
              ? clientDetails?.map((item) => ({ id: item?._id }))
              : [
                  {
                    id: clientDetails?._id,
                  },
                ],
          },
        },
        successCallback: (response) => {
          setApprovalLoading(false);

          dispatch(
            alertDialogAciton({
              open: true,
              title: "Alert!",
              message:
                response?.message || "Client Profile verified Successfully.",
            }),
          );

          if (onApproved) {
            onApproved();
          }

          handleClose();
        },
        failureCallback: (msg) => {
          setApprovalLoading(false);
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Error",
              message: msg || "Failed to verify client profile.",
            }),
          );
        },
      }),
    );
  };

  const ClientDetails = ({ clientDetails }) => {
    return (
      <Box
        sx={{
          width: "100%",
          border: "1px solid",
          borderColor: getCssVariableHandler({
            variableName: "--primary-pink-hex",
          }),
          borderRadius: "0.5rem",
          padding: "0.25rem 0.5rem",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: isSmallScreen ? "0" : "1rem",
            flexWrap: "wrap",
            flexDirection: isSmallScreen ? "column" : "row",
            width: "100%",
          }}
        >
          {clientDetails?.companyName && (
            <Typography
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: isSmallScreen ? "0.25rem" : "0.5rem",
                width: isSmallScreen ? "100%" : "47%",
              }}
            >
              <Typography
                sx={{
                  color: getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  }),
                  fontWeight: "500",
                }}
              >
                Company:{" "}
              </Typography>
              <Typography>{clientDetails?.companyName} </Typography>
            </Typography>
          )}
          {(clientDetails?.firstName || clientDetails?.lastName) && (
            <Typography
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: isSmallScreen ? "0.25rem" : "0.5rem",
                width: isSmallScreen ? "100%" : "47%",
              }}
            >
              <Typography
                sx={{
                  color: getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  }),
                  fontWeight: "500",
                }}
              >
                Name:{" "}
              </Typography>
              <Typography>
                {clientDetails?.firstName + " " + clientDetails?.lastName}{" "}
              </Typography>
            </Typography>
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: isSmallScreen ? "0" : "1rem",
            width: "100%",
            flexWrap: "wrap",
            flexDirection: isSmallScreen ? "column" : "row",
          }}
        >
          <Typography
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              gap: isSmallScreen ? "0.25rem" : "0.5rem",
              width: isSmallScreen ? "100%" : "47%",
            }}
          >
            <Typography
              sx={{
                color: getCssVariableHandler({
                  variableName: "--primary-pink-hex",
                }),
                fontWeight: "500",
              }}
            >
              Phone:{" "}
            </Typography>
            <Typography>{phoneNumberFormat(clientDetails?.mobile)}</Typography>
          </Typography>

          <Typography
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              gap: isSmallScreen ? "0.25rem" : "0.5rem",
              width: isSmallScreen ? "100%" : "47%",
            }}
          >
            <Typography
              sx={{
                color: getCssVariableHandler({
                  variableName: "--primary-pink-hex",
                }),
                fontWeight: "500",
              }}
            >
              Email:{" "}
            </Typography>
            <Typography>{clientDetails?.email} </Typography>
          </Typography>
        </Box>
      </Box>
    );
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "left",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Box
          sx={{
            ...style,
            display: "flex",
            flexDirection: "column",
            justifyContent: "left",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: 400,
              mb: 2,
              textAlign: "left",
              width: "100%",
              color: "#D175B6",
            }}
          >
            Alert!
          </Typography>
          <Typography
            sx={{
              fontWeight: 400,
              mb: 2,
              textAlign: "left",
              width: "100%",
              lineHeight: "1.6",
              fontSize: "18px",
            }}
          >
            {_.isArray(clientDetails)
              ? "The following profiles are not verified. Do you want to veriry and assign?"
              : isGenerateEstimate
                ? "The profile assigned to this event is not yet verified. Please review the details below and verify them before generating the estimate."
                : "The profile you are trying to assign is not verified, Do you want to verify and assign?"}
          </Typography>

          <Typography
            sx={{
              textAlign: "left",
              width: "100%",
              fontWeight: "500",
              fontSize: "1.15rem",
            }}
          >
            Client Details:
          </Typography>

          <Box
            sx={{
              width: "100%",
              overflowY: "auto",
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: "column",
              gap: "0.5rem",
              maxHeight: "35vh",
            }}
          >
            {_.isArray(clientDetails)
              ? clientDetails?.map((item) => {
                  return ClientDetails({ clientDetails: item });
                })
              : ClientDetails({ clientDetails })}
          </Box>

          <Box
            sx={{
              mt: 3,
              display: "flex",
              gap: 2,
              justifyContent: "right",
              width: "100%",
            }}
          >
            <Button
              onClick={handleClose}
              style={{
                backgroundColor: "#000",
                borderRadius: "8px",
                border: "none",
                color: "#fff",
                padding: "8px 16px",
                cursor: "pointer",
                boxShadow: "gray 0px 0px 20px 0px inset",
              }}
            >
              Close
            </Button>
            <Button
              onClick={handleApprove}
              disabled={approvalLoading || row?.isApproved}
              style={{
                backgroundColor: "rgb(209, 117, 182)",
                boxShadow:
                  "rgba(255, 0, 255, 0.3) 0px 30px 80px 0px, rgba(0, 0, 0, 0.6) 0px 0px 20px 0px inset",
                borderRadius: "8px",
                border: "none",
                color: "#fff",
                padding: "8px 16px",
                cursor: approvalLoading ? "not-allowed" : "pointer",
              }}
            >
              {approvalLoading ? (
                <CircularProgress size={24} sx={{ color: "white" }} />
              ) : isAssign ? (
                "Verify and Assign"
              ) : (
                "Verify Profile"
              )}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

ClientApproveModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  row: PropTypes.object,
  onApproved: PropTypes.func,
  isGenerateEstimate: PropTypes.bool,
  isAssign: PropTypes.bool,
};
